// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1z_s5","ul":"Sidebar_ul__3zX7c","li":"Sidebar_li__vN-pm"};